import { useTableContext } from "#Contexts/TableContext"

const EmptyState = ({ title, content, children, centerInContainer = false }) => {
  const { table, error, loading, dataSize, tableContainerRef } = useTableContext()

  if (loading) return null
  if (error) return null
  if (dataSize > 0) return null

  if (centerInContainer) {
    return (
      <tbody className="empty-table">
        <tr>
          <td colSpan={table.getFlatHeaders().length} className="c-table__td relative">
            <div
              className="relative inset-0 flex flex-col justify-center items-center py-4 pointer-events-none"
              style={{
                left: tableContainerRef?.current ? -tableContainerRef.current.scrollLeft : 0,
                width: tableContainerRef?.current?.clientWidth || "100%",
              }}
            >
              {children !== undefined && children}
              {children === undefined && (
                <>
                  <i className="text-2xl mb-4 text-content-muted fa fa-search block text-center" />
                  <h2 className="c-heading--base text-center">{title || "No data found"}</h2>
                  <p className="text-content-secondary text-center">
                    {content || "We haven't found any data for this timeframe"}
                  </p>
                </>
              )}
            </div>
          </td>
        </tr>
      </tbody>
    )
  }

  return (
    <tbody className="empty-table">
      <tr>
        <td colSpan={table.getFlatHeaders().length} className="c-table__td">
          <div className="flex flex-col w-full h-full justify-center items-center py-4">
            {children !== undefined && children}
            {children === undefined && (
              <>
                <i className="text-2xl mb-4 text-content-muted fa fa-search" />
                <h2 className="c-heading--base">{title || "No data found"}</h2>
                <p className="text-content-secondary text-center">
                  {content || "We haven't found any data for this timeframe"}
                </p>
              </>
            )}
          </div>
        </td>
      </tr>
    </tbody>
  )
}

EmptyState.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  content: PropTypes.string,
  centerInContainer: PropTypes.bool,
}

export default EmptyState
